import { boolean, InferType, number, object, string } from "yup";
import { TLangType } from "./LangType";

export const rdAvailableSchema = object({
    id: number().required(),
    domain: string().required(),
    thematic: string().required(),
    isChecked: boolean(),
    lang: string<TLangType>().default("FR"),
    pbn: string().required(),
    price: number().required(),
    da: number().notRequired(),
    tf: number().notRequired(),
    ttf: string().notRequired(),
    rd: number().notRequired(),
    cf: number().notRequired(),
    traffic: number().notRequired(),
    kw: number().notRequired(),
    googleResult: number().notRequired(),
});
export type rdAvailable = InferType<typeof rdAvailableSchema>;
